import React from "react";

const LikeFilledIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M6.99186 6.72091V15.1876C6.99186 15.7042 7.23353 16.1959 7.64186 16.5042L8.70853 17.3292C9.06686 17.6876 9.85019 17.8792 10.4085 17.8792H13.6585C14.7752 17.8792 15.9002 17.0376 16.1585 16.0042L18.2085 9.76257C18.4169 9.17091 18.3585 8.58757 18.0419 8.13757C17.7085 7.67091 17.1419 7.40424 16.4835 7.40424H13.0585C12.8335 7.40424 12.6252 7.30424 12.4835 7.14591C12.3419 6.97091 12.2752 6.74591 12.3085 6.49591L12.7419 3.77091C12.9169 2.95424 12.3752 2.03757 11.5585 1.76257C10.8002 1.47924 9.90853 1.86257 9.55019 2.40424L7.27519 5.78757C7.09186 6.06257 6.99186 6.38757 6.99186 6.72091Z"
        fill="#070B12"
      />
      <path
        d="M3.48341 5.09593H4.34175C5.63341 5.09593 6.15841 5.59593 6.15841 6.82927V15.2126C6.15841 16.4459 5.63341 16.9459 4.34175 16.9459H3.48341C2.19175 16.9459 1.66675 16.4459 1.66675 15.2126V6.82927C1.66675 5.59593 2.19175 5.09593 3.48341 5.09593Z"
        fill="#070B12"
      />
    </svg>
  );
};

export default LikeFilledIcon;
